import { useForm } from 'react-hook-form';
import { useAddSSHKeyMutation } from './useAddSSHKeyMutate';

interface AddSSHKeyValues {
    name: string;
    content: string;
}

interface UseAddSSHKeyFormProps {
    onSuccess?: () => void;
}

export function useAddSSHKeyForm({ onSuccess }: UseAddSSHKeyFormProps = {}) {
    const mutation = useAddSSHKeyMutation();

    const {
        formState: { errors },
        handleSubmit,
        register,
        reset,
    } = useForm<AddSSHKeyValues>({
        mode: 'onChange',
        defaultValues: {
            name: '',
            content: '',
        },
    });

    const onSubmit = handleSubmit((values) => {
        mutation.mutate(values, {
            onSuccess: () => {
                reset();
                onSuccess?.();
            },
        });
    });

    return {
        isSubmitting: mutation.isPending,
        errors,
        register,
        reset,
        onSubmit,
    };
}
